import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import BrandMark from "@/components/BrandMark";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-950">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-pulse">
            <BrandMark size={40} onDark />
          </div>
          <p className="text-sm text-slate-400">Loading EduPulse…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "super_admin" ? "/super" : "/school"} replace />;
  }

  return children;
}
